module.exports = __webpack_public_path__ + "static/media/yf.c889a895.jpg";